import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import Button from "../../../../ui/molecules/button";
import Input from "../../../../ui/molecules/input";
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch";
import { GGNotificationCreation, resetGGNotificationCreationReuqest, setGGNotCreationCoopModule, setGGNotCreationEntryProtocolId, setGGNotCreationGraspModule, setGGNotCreationOtherType, setGGNotCreationSpringModule, setGGNotCreationStandard, setGGNotCreationStandardOptions, setGGNotCreationStandardSubfield, setGGNotCreationType, setGGNotCreationValutationDate, setGGNotCreationValutationNote, setGGNotCreationValutationResult, setGGNotificationCreationCustomerId } from "../dataservice/slice";
import { SelectCustom } from "../../../../ui/molecules/select";
import { SingleCheckbox } from "../../../../ui/molecules/SingleCheckbox";
import TextArea from "../../../../ui/molecules/textArea";
import { GGNotificationTypeOptions, GGStandardOptions, GGStandardSubfieldOptions, GGStandardOptionOptions, GGValutationResultOptions } from "../../../../utils";
import { Calendar } from "../../../../ui/molecules/calendar";

interface Props {
    close: () => void
}

export function GlobalGapNotificationAddPopup(props: Props) {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const ggNotificationState = useAppSelector(state => state.ggNotification)  
    const [GRASPFlag, setGRASPFlag] = useState<boolean>(false)
    const [COOPFlag, setCOOPFlag] = useState<boolean>(false)
    const [SPRINGFlag, setSPRINGFlag] = useState<boolean>(false)  

    useEffect(() => {
        dispatch(setGGNotificationCreationCustomerId(sessionState.selected.customerId))
    }, [])

    useEffect(() => {
        if(ggNotificationState.ggNotificationCreationStatus === 'successfully') {
            dispatch(resetGGNotificationCreationReuqest())
            props.close()
        }
    }, [ggNotificationState.ggNotificationCreationStatus])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>
                <div className="pb-5">
                    <ProtocolSearch
                        type="entry"
                        defaultValue={ggNotificationState.ggNotificationCreationRequest.entryProtocolId}
                        onSelect={(value) => dispatch(setGGNotCreationEntryProtocolId(value))}
                    />
                </div>

                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left notify-text-bold'>
                            Tipologia
                        </div>
                        <SelectCustom
                            placeholder='Seleziona tipologia...'
                            value={ggNotificationState.ggNotificationCreationRequest.type}
                            options={GGNotificationTypeOptions}
                            onChange={(value) => dispatch(setGGNotCreationType(value))}
                        />
                    </div>

                    <div style={{ flex: '0.5' }}>
                        <div className='text-left notify-text-bold'>
                            Tipologia Altro
                        </div>
                        <Input
                            placeholder='Specifica tipologia altro...'
                            value={ggNotificationState.ggNotificationCreationRequest.otherType}
                            onChangeText={(text) => dispatch(setGGNotCreationOtherType(text))}
                        />
                    </div>
                </div>

                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <div className='text-left notify-text-bold'>
                            Standard
                        </div>
                        <SelectCustom
                            placeholder='Seleziona standard...'
                            value={ggNotificationState.ggNotificationCreationRequest.standard}
                            options={GGStandardOptions}
                            onChange={(value) => dispatch(setGGNotCreationStandard(value))}
                        />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <div className='text-left notify-text-bold'>
                            Standard Sottocampo
                        </div>
                        <SelectCustom
                            placeholder='Seleziona sottocampo...'
                            value={ggNotificationState.ggNotificationCreationRequest.standardSubfield}
                            options={GGStandardSubfieldOptions}
                            onChange={(value) => dispatch(setGGNotCreationStandardSubfield(value))}
                        />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <div className='text-left notify-text-bold'>
                            Standard Opzione
                        </div>
                        <SelectCustom
                            placeholder='Seleziona opzione...'
                            value={ggNotificationState.ggNotificationCreationRequest.standardOption}
                            options={GGStandardOptionOptions}
                            onChange={(value) => dispatch(setGGNotCreationStandardOptions(value))}
                        />
                    </div>
                </div>

                <div className="pb-5 pt-3" style={{ display: 'flex', gap: '72px', borderBottom: '1px solid #d9e6e8' }}>
                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left notify-text-bold'>
                            Modulo GRASP
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={GRASPFlag}
                            setChecked={(value) => {
                                dispatch(setGGNotCreationGraspModule(value))
                                setGRASPFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left notify-text-bold'>
                            Modulo COOP Italia
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={COOPFlag}
                            setChecked={(value) => {
                                dispatch(setGGNotCreationCoopModule(value))
                                setCOOPFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left notify-text-bold'>
                            Modulo Spring
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={SPRINGFlag}
                            setChecked={(value) => {
                                dispatch(setGGNotCreationSpringModule(value))
                                setSPRINGFlag(value)
                            }}
                        />
                    </div>
                </div>

                <div className="pb-5 pt-5" style={{ display: 'flex', gap: '24px' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left notify-text-bold'>
                            Data Valutazione
                        </div>
                        <Calendar
                            selected={ggNotificationState.ggNotificationCreationRequest.valutationDate}
                            onChange={(date) => dispatch(setGGNotCreationValutationDate(date))}
                        />
                    </div>

                    <div style={{ flex: '0.5' }}>
                        <div className='text-left notify-text-bold'>
                            Esito Valutazione
                        </div>
                        <SelectCustom
                            placeholder='Seleziona modulo...'
                            value={ggNotificationState.ggNotificationCreationRequest.valutationResult}
                            options={GGValutationResultOptions}
                            onChange={(value) => dispatch(setGGNotCreationValutationResult(value))}
                        />
                    </div>
                </div>

                <div className="pb-5">
                    <div>
                        <div className='text-left notify-text-bold'>
                            Esito Valutazione
                        </div>
                        <TextArea
                            value={ggNotificationState.ggNotificationCreationRequest.valutationNote}
                            onChangeText={(text) => dispatch(setGGNotCreationValutationNote(text))}
                        />
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        dispatch(resetGGNotificationCreationReuqest())
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(GGNotificationCreation(ggNotificationState.ggNotificationCreationRequest))}
                    />
                </div>
            </div>
        </div>
    )
}